import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { PrivateDistributionListMember } from 'owa-persona';

export const addFavoritePrivateDistributionList = action(
    'addFavoritePrivateDistributionList',
    (
        displayName: string,
        members: PrivateDistributionListMember[],
        pdlId: string,
        owsPersonaId: string,
        actionSource: string
    ) =>
        addDatapointConfig(
            {
                name: 'AddFavoritePrivateDistributionList',
                customData: {
                    actionSource,
                    isNew: !pdlId,
                },
            },
            {
                displayName,
                members,
                pdlId,
                owsPersonaId,
            }
        )
);
